import { TextField, EmailField, DateField } from 'react-admin'
import { Box, Typography, TypographyProps, styled } from '@mui/material'

export const Heading: React.FC<TypographyProps> = ({ children, ...props }) => {
  return (
    <Typography variant='h6' sx={{ color: '#ADB3BD', fontWeight: 'normal' }} {...props}>
      {children}
    </Typography>
  )
}

export const TextFieldStyled = styled(TextField)(({ theme }) => ({
  color: '#000000',
  fontWeight: 'normal',
  fontSize: theme.typography.subtitle1.fontSize,
}))

export const EmailFieldStyled = styled(EmailField)(({ theme }) => ({
    color: '#000000',
    fontWeight: 'normal',
    fontSize: theme.typography.subtitle1.fontSize,
  }))

export const DateFieldStyled = styled(DateField)(({ theme }) => ({
    color: '#000000',
    fontWeight: 'normal',
    fontSize: theme.typography.subtitle1.fontSize,
  }))

export const ContentWrapper = styled(Box)(() => ({ display: 'block', mb: 3 }))
